module.exports = __webpack_public_path__ + "e7a43f6945ea319eb0f4dca59ebbd22e.svg";